import styled from '@emotion/styled';
import { Ui } from '@silvertours/front-shared';

const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  margin-bottom: 2rem;

  ${({ theme }) => theme.mq('lg')} {
    grid-template-columns: 1fr 447px;
    align-items: end;
  }
`;

const FullWidthItem = styled.div`
  grid-column: 1 / -1;
`;

const FullWidthHeadingItem = styled.div`
  grid-column: 1 / -1;
  margin-bottom: -2.5rem;
`;

const LeftColumnItem = styled.div`
  grid-column: 1;
  margin-bottom: 1.75rem;
  margin-top: 2rem;

  ${({ theme }) => theme.mq('lg')} {
    margin-right: 1.5rem;
    margin-bottom: 0;
  }

  ${({ theme }) => theme.mq('xl')} {
    margin-right: 10rem;
  }
`;

const RightColumnItem = styled.div`
  grid-column: 1;

  ${({ theme }) => theme.mq('lg')} {
    grid-column: 2;
    align-self: end;
  }
`;

const StyledAdditionalInfo = styled(Ui.AdditionalInfo)`
  max-width: 447px;

  ${({ theme }) => theme.mq('lg')} {
    max-width: none;
  }
`;

export {
  GridWrapper,
  FullWidthItem,
  FullWidthHeadingItem,
  LeftColumnItem,
  RightColumnItem,
  StyledAdditionalInfo,
};
